<script lang="ts">
import type { HTMLAttributes } from 'vue'

export interface DataTableCellPopoverContentProps extends PopoverContentProps {
  class?: HTMLAttributes['class']
}
</script>

<script setup lang="ts">
import { cn } from '../../../lib/utils'
import { PopoverContent, type PopoverContentProps } from '../../ui/popover'

const props = withDefaults(defineProps<DataTableCellPopoverContentProps>(), {
  align: 'center'
})
</script>
<template>
  <PopoverContent v-bind="props" :class="cn('flex w-fit flex-col gap-2 p-0 text-sm', props.class)">
    <slot />
  </PopoverContent>
</template>
